import { INVITE_TYPE_LABEL } from '../guests'
import type { InviteType } from '../types'

/** A quiet marker of which invite somebody has. */
export function InviteBadge({ type }: { type: InviteType }) {
  return (
    <span
      className={`ml-1 align-middle rounded-full px-2 py-0.5 text-[0.65rem] tracking-widest uppercase ${
        type === 'evening' ? 'bg-ink/10 text-ink-soft' : 'bg-sage/20 text-sage'
      }`}
    >
      {INVITE_TYPE_LABEL[type]}
    </span>
  )
}
